import { render } from "./Customers.vue?vue&type=template&id=74783580"
import script from "./Customers.vue?vue&type=script&lang=ts"
export * from "./Customers.vue?vue&type=script&lang=ts"
script.render = render

export default script